module.exports = __webpack_public_path__ + "img/banner7.cb49b41b.png";